module.exports = __webpack_public_path__ + "media/2.a7a30d6e.wav";